// src/pages/Scanner.jsx
import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { Box, Typography, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";

//const CLIENT = "http://192.168.137.1:3000"; // change if frontend served on LAN*/
//const CLIENT =  process.env.REACT_APP_CLIENT;// ||  `${window.location.protocol}//${window.location.hostname}:3000`;
const CLIENT = window.location.origin;

export default function Scanner() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let scanner;

    try {
      scanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

      scanner.render(
        (decodedText) => {
          let path = decodedText;

          // If QR contains absolute client URL, strip it
          if (path.startsWith(CLIENT)) {
            path = path.replace(CLIENT, "");
          }

          // Try parsing URL safely
          try {
            const url = new URL(decodedText);
            path = url.pathname + url.search;
          } catch {
            // ignore parsing errors; treat as relative
          }

          scanner.clear().then(() => {
            navigate(path);
          });
        },
        (err) => {
          // Ignored continuous scan failures
          console.warn("Scan issue:", err);
        }
      );
    } catch (err) {
      console.error(err);
      setError(
        "Unable to access camera. Please allow camera permission and try again."
      );
    }

    return () => {
      if (scanner) {
        try {
          scanner.clear();
        } catch {
          // ignore cleanup errors
        }
      }
    };
  }, [navigate]);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Scan QR Code
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Typography variant="body2" sx={{ textAlign: "center", mb: 1 }}>
        Point the camera at a museum QR code.
      </Typography>

      <div id="reader" style={{ width: 320, margin: "auto" }} />
    </Box>
  );
}